import { GetOnboardMeta, GetOnboardPayload } from 'types/store/GetOnboardState';
import { createAsyncReducer } from 'utils/Redux';

import { getOnboardActions } from '../actions';

export default createAsyncReducer<GetOnboardMeta, GetOnboardPayload>(getOnboardActions);
